export const store = {
  state: {
    drawer: false,
    email: localStorage.getItem("drs_user"),
    role: localStorage.getItem("drs_role"),
    token: localStorage.getItem("drs_token"),
    refresh_token: localStorage.getItem("drs_refresh_token"),
    googleAPI: localStorage.getItem("drs_googleAPI"),
    infoDialog: {
      type: '',
      active: false,
      title: 'メッセージ',
      content: '',
      onClose: null,
    },
    confirmDialog: {
      active: false,
      title: '',
      content: '',
      onAgree: null,
      onDisagree: null,
    },
    loading: false,
    snackbar: {
      active: false,
      content: '',
      onClose: null
    },
    showSnackbar: false,
    sideTab: [],
    breadcrumbs: {
      mapview: [],
      report: []
    }
  },
  updateLoginStatus(email, role, token, refresh_token) {
    this.state.email = email;
    this.state.role = role;
    this.state.token = token;
    this.state.refresh_token = refresh_token;
    localStorage.setItem("drs_user", email);
    localStorage.setItem("drs_role", role);
    localStorage.setItem("drs_token", token);
    localStorage.setItem("drs_refresh_token", refresh_token);
  },
  updateLogoutStatus() {
    this.state.email = null;
    this.state.role = null;
    this.state.token = null;
    this.state.refresh_token = null;
    this.state.googleAPI = false;
    localStorage.removeItem("drs_user");
    localStorage.removeItem("drs_role");
    localStorage.removeItem("drs_token");
    localStorage.removeItem("drs_refresh_token");
    localStorage.removeItem("drs_googleAPI");
  },
  updateGoogleAPI() {
    this.state.googleAPI = true;
    localStorage.setItem("drs_googleAPI", true);
  },
  showInfoDialog(infoDialog) {
    this.state.infoDialog.active = true;
    this.state.infoDialog.type = infoDialog.type;
    this.state.infoDialog.content = infoDialog.content;
    this.state.infoDialog.onClose = infoDialog.onClose;
  },
  closeInfoDialog() {
    this.state.infoDialog.active = false;
    if (this.state.infoDialog.onClose) {
      this.state.infoDialog.onClose();
    }
    this.resetInfoDialog();
  },
  showSuccessDialog(message, onClose = null) {
    let infoDialog;
    infoDialog = {
      type: 'success',
      content: message,
      onClose: onClose,
    };
    this.showInfoDialog(infoDialog);
  },
  showErrorDialog(message, onClose = null) {
    let infoDialog;
    infoDialog = {
      type: 'error',
      content: message,
      onClose: onClose,
    };
    this.showInfoDialog(infoDialog);
  },
  showConfirmDialog(confirmDialog) {
    this.state.confirmDialog.active = true;
    this.state.confirmDialog.title = confirmDialog.title;
    this.state.confirmDialog.content = confirmDialog.content;
    this.state.confirmDialog.onAgree = confirmDialog.onAgree;
    this.state.confirmDialog.onDisagree = confirmDialog.onDisagree;
  },
  agreeConfirmDialog() {
    this.state.confirmDialog.active = false;
    if (this.state.confirmDialog.onAgree) {
      this.state.confirmDialog.onAgree();
    }
    this.resetConfirmDialog();
  },
  disagreeConfirmDialog() {
    this.state.confirmDialog.active = false;
    if (this.state.confirmDialog.onDisagree) {
      this.state.confirmDialog.onDisagree();
    }
    this.resetConfirmDialog();
  },
  resetInfoDialog() {
    this.state.infoDialog.active = false;
    this.state.infoDialog.type = '';
    this.state.infoDialog.content = '';
    this.state.infoDialog.onClose = null;
  },
  resetConfirmDialog() {
    this.state.confirmDialog.active = false;
    this.state.confirmDialog.title = '';
    this.state.confirmDialog.content = '';
    this.state.confirmDialog.onAgree = null;
    this.state.confirmDialog.onDisagree = null;
  },
  showLoadingOverlay(status){
    this.state.loading = status;
  },
  showSnackBar(message, onClose = null){
    this.state.snackbar.active = true;
    this.state.snackbar.content = message;
    this.state.snackbar.onClose = onClose
  },
  closeSnackBar(){
    this.state.snackbar.active = false;
    if (this.state.snackbar.onClose){
      this.state.snackbar.onClose();
    }
    this.resetSnackbar()
  },
  resetSnackbar(){
    this.state.snackbar.active = false;
    this.state.snackbar.content = '';
    this.state.snackbar.onClose = null;
  },
  updateSideBar(colors){
    this.state.sideTab = colors
  },
  updateMapviewBreadcrumbs(breadcrumbs){
    this.state.breadcrumbs.mapview = breadcrumbs;
  },
  updateReportBreadcrumbs(breadcrumbs){
    this.state.breadcrumbs.report = breadcrumbs;
  }
}
